import { PropsWithChildren, ReactElement } from 'react';
import styles from './MapLoader.module.scss';
import Skeleton from 'react-loading-skeleton';
import { ProgressIndicatorCircular } from '@dmc/ui';

interface MapLoaderProps {
  showMap: boolean;
  isFetching: boolean;
  height?: string | number;
}

export const MapLoader = ({
  showMap,
  isFetching,
  children,
  height = '100%',
}: PropsWithChildren<MapLoaderProps>): ReactElement => {
  return (
    <div className={styles.mapArea} style={{ height }}>
      {showMap ? (
        <>
          <div className={`${styles.map} ${isFetching && styles['map--fetching']}`}>{children}</div>
          {isFetching && (
            <div className={styles.loadingOverlay}>
              <ProgressIndicatorCircular small />
            </div>
          )}
        </>
      ) : (
        <Skeleton width="100%" height="100%" />
      )}
    </div>
  );
};

export default MapLoader;
